import Spinner from "components/General-UI/Spinner";
import { iAmAdmin } from "helpers/efficeHelpers";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  ALL_MEMBERS_TEXT_TYPE,
  changeEfficePermissions,
  ONLY_ADMIN_TEXT_TYPE,
} from "slices/peopleSlice";

const PermissionsList = ({ permissionsEffice }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  return (
    <div className="permissions-list">
      <label htmlFor="permissions">
        Who can send messages in this channel :&nbsp;&nbsp;&nbsp;&nbsp;
      </label>
      {iAmAdmin(permissionsEffice) ? (
        <select
          name="permissions"
          onChange={(e) => {
            setLoading(true);
            dispatch(
              changeEfficePermissions(
                permissionsEffice.id,
                parseInt(e.target.value)
              )
            )
              .then(() => {
                setLoading(false);
              })
              .catch(() => {
                setLoading(false);
              });
          }}
          value={permissionsEffice.type}
        >
          <option value={ONLY_ADMIN_TEXT_TYPE}>Only Admins</option>
          <option value={ALL_MEMBERS_TEXT_TYPE}>All Members</option>
        </select>
      ) : permissionsEffice.type === ONLY_ADMIN_TEXT_TYPE ? (
        "Only Admins"
      ) : (
        "All Members"
      )}
      <>
        {loading ? (
          <span className="Txt-change-permissions-loader">
            <Spinner
              bgDark={false}
              spinnerLight={false}
              immediateShow={true}
              small={true}
            />
          </span>
        ) : null}
      </>
    </div>
  );
};

export default PermissionsList;
